/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toAdmissionProps, toAdmissionRequest } from './translator/admission'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchAdmission, PutAdmission } from '@/infrastructure/network/Monitaro/requests/admission'
import { IAdmissionProps } from '@/entities/Admission'

export default class Admission extends MonitaroGatewayBase {
  async FetchAdmission(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchAdmission(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.admissions.map((prop) => toAdmissionProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async PutAdmission(admission: string, params: IAdmissionProps) {
    const { admissions } = await this.apiClient.request(new PutAdmission(admission, toAdmissionRequest(params)))
    return toAdmissionProps(admissions)
  }
}
